import { combineReducers } from "@reduxjs/toolkit";

//import new slicer optimized
import pvc_checkListReducer from "./slices/pvc_checklsit.slices.js";
import pvi_checkListReducer from "./slices/pvi_checklist.slices.js";
import afe_checkListReducer from "./slices/afe_checkList.sllices.js";
import pva_testReportReducer from "./slices/pva_testReport.slices.js";
import Inspection_InfoReducer from "./slices/inspection_info.slices.js";

const rootReducer = combineReducers({
  ins_info: Inspection_InfoReducer,
  pvc_list: pvc_checkListReducer,
  pvi_list: pvi_checkListReducer,
  afe_list: afe_checkListReducer,
  pva_test: pva_testReportReducer,
});

export default rootReducer;
